import {CheckboxAttribute} from '@/_application/modules/products/components/attributes/checkbox.attribute';
import {ColorAttribute} from '@/_application/modules/products/components/attributes/color.attribute';
import {ConfigurableAttributeOption} from '../../../../../../__generated__/__types__';

export type ProductAttributeProps = {
    attribute: ConfigurableAttributeOption;
    currentOption?: number;
    isActive?: boolean;
    isDisabled?: boolean;
    className?: string;
    color?: string;
    variant?: 'normal' | 'outline';
    onSelected?: (value?: number) => void;
    [key: string]: unknown;
};
function ProductAttribute({attribute, currentOption, isDisabled, onSelected}: ProductAttributeProps) {
    switch (attribute.code) {
        case 'color':
            return (
                <ColorAttribute
                    attribute={attribute}
                    currentOption={currentOption}
                    onSelected={onSelected}
                    isDisabled={isDisabled}
                />
            );
        default:
            return (
                <CheckboxAttribute
                    attribute={attribute}
                    currentOption={currentOption}
                    onSelected={onSelected}
                    isDisabled={isDisabled}
                />
            );
    }
}

export default ProductAttribute;
